// @flow
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import SocialIcons from "./SocialIcons";
import Hidden from "@material-ui/core/Hidden";
import LoginButtons from "./LoginButtons";
import IconButton from "@material-ui/core/IconButton";
import PublicSidebar from "./PublicSidebar";
import { Link } from "react-router-dom";

import logo from "routes/public/Home2/homeSources/icpc-medium5.png";
import logocmplay from "routes/public/Home2/homeSources/icpc-medium5-cmplay.png";
import withWidth from "@material-ui/core/withWidth";
import { down } from "common/utils/responsive";
import MdMenu from "react-ionicons/lib/MdMenu";
import type { Route } from "types/Router";
import type { MenuItem } from "containers/PublicApp/types";

const styles = (theme) => ({
  appBarModified: {
    // PREPARE FOR GRADIENT
    // minHeight: "140px",
    // backgroundColor: "rgba(0, 0, 0, 0)",

    // backgroundColor: theme.palette.primaryOriginal[700],
    [theme.breakpoints.down("xs")]: {
      height: 56,
    },
    zIndex: theme.zIndex.drawer + 200,
    //experiment
    backgroundImage: "linear-gradient(to left, #164174 , #143356)",
  },
  flex: {
    flex: 1,
  },
  logo: {
    padding: "5px",
    transform: "scale(0.75)",
    width: "228px",
    [theme.breakpoints.down("xs")]: {
      transform: "scale(0.58)",
    },
    //filter: "brightness(10)"
    // "&:hover": {
    //   filter: "brightness(1)"
    // },
  },
  logoNoMenu: {
    marginLeft: "-25px",
  },
  persistentNavbar: {
    width: 310,
  },
  content: {
    WebkitOverflowScrolling: "touch",
    overflowY: "scroll",
    overflowX: "hidden",
    // marginTop: 77
  },
  contentShift: {
    marginLeft: 310,
  },
  pageWrap: {
    height: "calc(100vh - 77px)",
    // overflowY: "scroll",
    // WebkitOverflowScrolling: "touch",
    marginTop: "77px",
    maxWidth: "100vw",
    // overflowX: "hidden",
    [theme.breakpoints.down("xs")]: {
      height: "calc(100vh - 56px)",
      marginTop: "56px",
    },
    WebkitOverflowScrolling: "touch",
  },
  menu: {
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
});

type Props = Route & {
  classes: Object,
  isLoggedIn: boolean,
  name: string,
  redirect: (string) => void,
  login: string,
  logout: string,
  register: string,
  persistent?: boolean,
  menuBorder?: boolean,
  match: Object,
  showMessage: (string) => void,
  hideMessage: () => void,
  menuItems: Array<MenuItem>,
  width: string,
  children: any,
};

type State = {
  open: boolean,
  scrollPercentage: 0,
};

class PublicAppFrame extends Component<Props, State> {
  state: State = {
    open: false,
    scrollPercentage: 0,
  };

  handleClick = (event) => {
    this.setState({ open: !this.state.open });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, width, children } = this.props;
    const persistent = down("sm", width) ? false : this.props.persistent;
    const cmplay = window.location.href.includes("cmplay.ecs.baylor.edu");
    return (
      <div className={classes.pageWrap}>
        <AppBar
          position="fixed"
          className={
            classes.appBarModified // className={classes.appBar + " easegradient"} //prepare for GRADIENT
          }
          elevation={3}
        >
          <Toolbar aria-label="Menu" className={classes.menu}>
            {/* tablet to desktop screen top bar, some elements disappear with smaller screen size/ */}
            <Hidden xsDown>
              <IconButton
                onClick={this.handleClick}
                style={{ position: "relative", top: 4, color: "#fff" }}
              >
                <MdMenu fontSize="26px" color="white" />
              </IconButton>

              <div className={classes.flex}>
                <Link to="/">
                  <img
                    style={{}}
                    src={cmplay ? logocmplay : logo}
                    alt="ICPC competition"
                    className={
                      persistent
                        ? classes.logo
                        : `${classes.logo} ${classes.logoNoMenu}`
                    }
                  />
                </Link>
              </div>
              <Hidden mdDown>
                <SocialIcons />
              </Hidden>
              <Hidden xsDown>
                <LoginButtons
                  isLoggedIn={this.props.isLoggedIn}
                  name={this.props.name}
                  login={this.props.login}
                  logout={this.props.logout}
                  register={this.props.register}
                  redirect={this.props.redirect}
                />
              </Hidden>
              {/*The functionality to search for wiki contents is disabled because
              normally people just use search engine like Google, etc. to search for
              things, and search engines are pretty good. If the functionality is
              demanded to be brought back, talk to Dr. Donahoo regarding it before
              implementation because previously we used the search functionality of
              xwiki website but now we will have to search on the contents in database
              The rest endpoint in relation to it will need to be implemented properly.*/}
              {/*<Hidden smDown>*/}
              {/*  <SearchInput*/}
              {/*    onSubmit={query => {*/}
              {/*      redirect(`/search/${query}`);*/}
              {/*      hideMessage();*/}
              {/*    }}*/}
              {/*    onMinError={length => showMessage(`Min 3 letters required`)}*/}
              {/*    resetOnSubmit*/}
              {/*  />*/}
              {/*</Hidden>*/}
            </Hidden>
            {/* mobile toolbar with menu on the right side */}
            <Hidden smUp>
              <div className={classes.flex}>
                <Link to="/">
                  <img
                    src={logo}
                    alt="ICPC competition"
                    className={
                      persistent
                        ? classes.logo
                        : `${classes.logo} ${classes.logoNoMenu}`
                    }
                  />
                </Link>
              </div>
              <LoginButtons
                isLoggedIn={this.props.isLoggedIn}
                name={this.props.name}
                login={this.props.login}
                logout={this.props.logout}
                register={this.props.register}
                redirect={this.props.redirect}
              />
              {!persistent && (
                <IconButton
                  onClick={this.handleClick}
                  style={{ position: "relative", top: 4, color: "#fff" }}
                >
                  <MdMenu fontSize="34px" color="white" />
                </IconButton>
              )}
            </Hidden>
          </Toolbar>
        </AppBar>
        <PublicSidebar
          open={this.state.open}
          handleRequestClose={this.handleRequestClose}
          border={this.props.menuBorder}
          items={this.props.menuItems}
          space={this.props.match.params && this.props.match.params.space}
          openSide={width === "xs" ? "right" : "left"}
        />
        <main className={classes.content}>{children}</main>
      </div>
    );
  }
}

export default withStyles(styles)(withWidth()(PublicAppFrame));
